import React, { useCallback } from 'react';
import { HiOutlineExclamation } from 'react-icons/hi';
import {
  Button,
  Center,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import {
  useDeleteCategorieMutation,
  useDeleteFaqMutation,
} from '@spartalabs/pdc-core';
import { useCustomToast } from 'hooks';

interface CancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  categorie?: Categorie | null;
  faq?: Faq | null;
}

export const DeleteModal = ({
  isOpen,
  onClose,
  categorie,
  faq,
}: CancelModalProps) => {
  const [deleteCat, { isLoading: deleteCatLoading }] =
    useDeleteCategorieMutation();
  const [deleteFaq, { isLoading: deleteFaqLoading }] = useDeleteFaqMutation();

  const { handleToast } = useCustomToast();

  const onSubmit = useCallback(async () => {
    try {
      if (categorie) await deleteCat({ id: categorie.id }).unwrap();

      if (faq) await deleteFaq({ id: faq.id }).unwrap();

      onClose();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      handleToast({
        step: 4,
        action: error
          ? error.data
          : `Algo deu errado ao deletar ${
              categorie ? 'a categoria' : 'o conteúdo'
            } `,
      });
    }
  }, [categorie, faq]);

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minW={{ base: '80%', md: '400px' }}
        py="24px"
        px="18px"
        bg="white"
      >
        <ModalCloseButton borderRadius="36px" color="black" />

        <ModalBody alignItems="center" py="0px " px="0px">
          <Center>
            <Icon
              borderRadius="100px"
              padding="16px"
              bg="grey.200"
              w="80px"
              h="80px"
              as={HiOutlineExclamation}
              color="grey.600"
            />
          </Center>
          <Text
            textAlign="center"
            mt="16px"
            p="0px"
            fontSize="lg"
            fontWeight={800}
            color="black"
            alignSelf="center"
          >
            Gostaria realmente de apagar essa{' '}
            {categorie ? 'categoria' : 'pergunta'}?
          </Text>
          <Text
            textAlign="center"
            p="0px 0 0px 0"
            fontSize="sm"
            color="grey.600"
          >
            Após apagar a {categorie ? 'categoria' : 'pergunta'} não será
            possível recuperar os dados
          </Text>
        </ModalBody>

        <ModalFooter mt="16px" p="0px">
          <Button variant="outline" onClick={onClose}>
            Voltar
          </Button>
          <Button
            isLoading={deleteCatLoading || deleteFaqLoading}
            ml="16px"
            onClick={onSubmit}
          >
            Apagar {categorie ? 'categoria' : 'pergunta'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
